import { ChevronUpDownOutline, ChevronUpDownAscendingOutline, ChevronUpDownDescendingOutline } from '@olist/design-system-icons';

const UNORDERED = 'UNORDERED';
const ASCENDING = 'ASC';
const DESCENDING = 'DESC';
const NONE = 'none';
const ARIA_ASC = 'ascending';
const ARIA_DESC = 'descending';
const ARIA_UNORDERED = 'none';
const orderingMap = {
    [UNORDERED]: ASCENDING,
    [ASCENDING]: DESCENDING,
    [DESCENDING]: ASCENDING,
};
const orderIconMap = {
    [UNORDERED]: ChevronUpDownOutline,
    [ASCENDING]: ChevronUpDownAscendingOutline,
    [DESCENDING]: ChevronUpDownDescendingOutline,
    [NONE]: () => null,
};
const ariaSortMap = {
    [ASCENDING]: ARIA_ASC,
    [DESCENDING]: ARIA_DESC,
    [UNORDERED]: ARIA_UNORDERED,
};

export { ARIA_ASC, ARIA_DESC, ARIA_UNORDERED, ASCENDING, DESCENDING, NONE, UNORDERED, ariaSortMap, orderIconMap, orderingMap };
